import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../core';
import { HttpClient } from '@angular/common/http';
import { BaseFormation } from '../base-formation';
import { GenericData, Category, eItem, SessionItem, CategorieModel } from '../../shared';
import { EndWithSlash } from 'projects/lib-components/src/public_api';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'webstore-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})

export class CategoriesComponent extends BaseFormation implements OnInit {

  public categories: GenericData<Category>[];

  constructor(
    public store: StoreService,
    protected http: HttpClient,
    protected router: Router
  ) {
    super(store);
  }

  ngOnInit(): void {
    const parentCatalog: SessionItem | null = super.getSession(eItem.CATALOG);
    if (parentCatalog) {
      this.store.showSplash(true);
      const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/categorie/getData/V2/INITDATA/${parentCatalog.id}`;
      this.http.get<CategorieModel>(destUrl).subscribe((data: CategorieModel): void => {
        if (!data.HasError) {
          if (data.CategorieList.length === 0)
            this.store.warning(this.store.getTrad('nocategory'));
          else
            this.categories = this.store.convertList<Category>(data.CategorieList, 2);
        }
        this.store.showSplash(false);
      }, (error: any): void => { JSON.stringify(error); });
    }
  }

  selectCategory(category: Category): void {
    if (category.TotProducts === 0)
      this.store.warning(this.store.getTrad('noproducts'));
    else {
      super.setCategory(category);
      this.router.navigateByUrl(this.store.AppRoutes.PRODUCTS);
    }
  }
}
